import React, { forwardRef, useEffect, useState } from 'react';
import { forceVisible } from 'react-lazyload';
import cn from 'clsx';

import Button from '../../library/button/button';
import ProductSpecifications from '../product-specifications/product-specifications';

import { Fitment } from '../../shared/types/fitment';
import { Maybe, ProductData, ToolTips } from '../../shared/types/graphql-types';

import styles from './product-details.scss';

interface ProductDetailsProps {
  className?: string;
  hideSizeTable?: boolean;
  isCanonicalSearch: boolean;
  product: ProductData;
  productType: string;
  selectedFitment: Fitment;
  shouldForceRenderLazyChildren?: boolean;
  storeCode?: Maybe<string>;
  tooltips: ToolTips;
}

const ProductDetails = forwardRef<HTMLDivElement, ProductDetailsProps>(
  function ProductDetails(props, ref) {
    const {
      className = '',
      hideSizeTable,
      isCanonicalSearch,
      product,
      productType,
      selectedFitment,
      shouldForceRenderLazyChildren,
      storeCode,
      tooltips
    } = props;

    const [descriptionExpanded, setDescriptionExpanded] = useState(false);

    useEffect(() => {
      if (shouldForceRenderLazyChildren) {
        forceVisible();
      }
    }, [shouldForceRenderLazyChildren]);

    return (
      <div
        className={cn(
          styles['product-details'],
          `product-details ${className}`
        )}
        ref={ref}
      >
        {(product?.longDescription || product?.description) && (
          <div
            className={cn(
              styles['product-description'],
              'product-details__product-description'
            )}
          >
            <div
              className={cn(
                descriptionExpanded
                  ? styles['description-expanded']
                  : styles['description-collapsed'],
                'cms-content'
              )}
              dangerouslySetInnerHTML={{
                __html: product?.longDescription ?? product.description ?? ''
              }}
            />

            {product?.longDescription && (
              <Button
                className={styles['product-description-expansion-button']}
                onClick={() => setDescriptionExpanded(!descriptionExpanded)}
              >
                {descriptionExpanded
                  ? 'read less'
                  : 'read full product description'}
              </Button>
            )}
          </div>
        )}
        {product && (
          <ProductSpecifications
            className={styles['product-specifications']}
            hideSizeTable={hideSizeTable}
            isCanonicalSearch={isCanonicalSearch}
            product={product}
            productType={productType}
            selectedFitment={selectedFitment}
            storeCode={storeCode}
            tooltips={tooltips}
          />
        )}
      </div>
    );
  }
);

export default ProductDetails;
